export default __webpack_public_path__ + "static/itreview-banner-sp-f2da7b9978f70a30e87a544475ea2fc1.png";